export const deduplicate = (array: any[]) => {
    return Array.from(new Set(array))
}


export const merge = (obj1: any = {}, obj2: any = {}) => {

    const commonFields = Object.keys(obj1).reduce((res: any, key) => {
        if (Array.isArray(res[key]) && !!obj2[key]) {
            return {
                ...res,
                [key]: deduplicate([...res[key], ...obj2[key]]),
            }
        }
        return res;
    }, obj1)

    const extraFields = Object.keys(obj2).reduce((res: any, key) => {
        if (!obj1[key] || !Array.isArray(obj1[key])) {
            return {
                ...res,
                [key]: obj2[key],
            }
        }
        return res;
    }, {})

    const projectStatus = obj2?.projectStatus?.length ? obj2.projectStatus : obj1.projectStatus;
    const bookStatus = obj2?.bookStatus?.length ? obj2.bookStatus : obj1.bookStatus;
    const useCalendar = obj1?.hasOwnProperty('useCalendar') && !!obj1?.useCalendar ? obj1?.useCalendar : obj2?.useCalendar;
    const isPaid = obj1?.hasOwnProperty('isPaid') && !!obj1?.isPaid ? obj1?.isPaid : obj2?.isPaid;
    const hasAnnotation = obj1?.hasOwnProperty('hasAnnotation') && !!obj1?.hasAnnotation ? obj1?.hasAnnotation : obj2?.hasAnnotation;
    const usingFilterOrManual = obj1?.hasOwnProperty('usingFilterOrManual') ? obj1?.usingFilterOrManual : obj2?.usingFilterOrManual;
    const lockSorting = obj1?.hasOwnProperty('lockSorting') ? obj1?.lockSorting : obj2?.lockSorting;
    const lockSortingType = obj1?.hasOwnProperty('lockSortingType') ? obj1?.lockSortingType : obj2?.lockSortingType;
    const broadcastLink = obj1?.hasOwnProperty('broadcastLink') ? obj1?.broadcastLink : obj2?.broadcastLink;

    return {
        ...commonFields,
        ...extraFields,
        ...(projectStatus ? { projectStatus } : {}),
        ...(bookStatus ? { bookStatus } : {}),
        ...(useCalendar ? { useCalendar } : {}),
        ...(isPaid ? { isPaid } : {}),
        ...(hasAnnotation ? { hasAnnotation } : {}),
        ...(usingFilterOrManual ? { usingFilterOrManual } : {}),
        ...(lockSorting ? { lockSorting } : {}),
        ...(lockSortingType ? { lockSortingType } : {}),
        ...(broadcastLink ? { broadcastLink } : {}),
        tags: [],
        requiredTags: [],
        exceptedTags: [],
    }
}export const deduplicate = (array: any[]) => {
    return Array.from(new Set(array))
}


export const merge = (obj1: any = {}, obj2: any = {}) => {

    const commonFields = Object.keys(obj1).reduce((res: any, key) => {
        if (Array.isArray(res[key]) && !!obj2[key]) {
            return {
                ...res,
                [key]: deduplicate([...res[key], ...obj2[key]]),
            }
        }
        return res;
    }, obj1)

    const extraFields = Object.keys(obj2).reduce((res: any, key) => {
        if (!obj1[key] || !Array.isArray(obj1[key])) {
            return {
                ...res,
                [key]: obj2[key],
            }
        }
        return res;
    }, {})

    const projectStatus = obj2?.projectStatus?.length ? obj2.projectStatus : obj1.projectStatus;
    const bookStatus = obj2?.bookStatus?.length ? obj2.bookStatus : obj1.bookStatus;
    const useCalendar = obj1?.hasOwnProperty('useCalendar') && !!obj1?.useCalendar ? obj1?.useCalendar : obj2?.useCalendar;
    const isPaid = obj1?.hasOwnProperty('isPaid') && !!obj1?.isPaid ? obj1?.isPaid : obj2?.isPaid;
    const hasAnnotation = obj1?.hasOwnProperty('hasAnnotation') && !!obj1?.hasAnnotation ? obj1?.hasAnnotation : obj2?.hasAnnotation;
    const usingFilterOrManual = obj1?.hasOwnProperty('usingFilterOrManual') ? obj1?.usingFilterOrManual : obj2?.usingFilterOrManual;
    const lockSorting = obj1?.hasOwnProperty('lockSorting') ? obj1?.lockSorting : obj2?.lockSorting;
    const lockSortingType = obj1?.hasOwnProperty('lockSortingType') ? obj1?.lockSortingType : obj2?.lockSortingType;
    const broadcastLink = obj1?.hasOwnProperty('broadcastLink') ? obj1?.broadcastLink : obj2?.broadcastLink;

    return {
        ...commonFields,
        ...extraFields,
        ...(projectStatus ? { projectStatus } : {}),
        ...(bookStatus ? { bookStatus } : {}),
        ...(useCalendar ? { useCalendar } : {}),
        ...(isPaid ? { isPaid } : {}),
        ...(hasAnnotation ? { hasAnnotation } : {}),
        ...(usingFilterOrManual ? { usingFilterOrManual } : {}),
        ...(lockSorting ? { lockSorting } : {}),
        ...(lockSortingType ? { lockSortingType } : {}),
        ...(broadcastLink ? { broadcastLink } : {}),
        tags: [],
        requiredTags: [],
        exceptedTags: [],
    }
}